/**
 * Design B footer sign-off: the wordmark letters rise into place as the
 * footer arrives, staggered from the centre out.
 */
import { scene, gsap } from '@theme/clinic-motion';

class ClinicSignoff extends HTMLElement {
  connectedCallback() {
    this.dispose = scene(this, ({ scroller }) => {
      const chars = this.querySelectorAll('.clinic-signoff__char');
      if (!chars.length) return;
      gsap.fromTo(
        chars,
        { yPercent: 105 },
        {
          yPercent: 0,
          ease: 'none',
          stagger: { each: 0.04, from: 'center' },
          scrollTrigger: {
            trigger: this.querySelector('[data-signoff-mark]'),
            scroller,
            start: 'top bottom',
            end: 'bottom bottom',
            scrub: 0.6,
          },
        }
      );
    });
  }

  disconnectedCallback() {
    this.dispose?.();
  }
}

if (!customElements.get('clinic-signoff')) customElements.define('clinic-signoff', ClinicSignoff);
